<template>
  <a-tree-select
      v-model:value="model.deptId"
      style="width: 100%"
      :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
      :tree-data="treeData"
      :replaceFields="{children:'children', title:'label', key:'id', value: 'id' }"
      :placeholder="title"
      tree-default-expand-all
  >
  </a-tree-select>
</template>
<script>
import {ref} from "vue";
import deptApi from '@axios/sys/dept'
export default {
  componentname: "selectDeptTree",
  props:{
    title:{
      type:String,
      default:'请选择部门'
    },
    disabled : {
      type:Boolean,
      default:false
    },
    model : {
      type : Object,
      default : function(){
        return {
          deptId : undefined
        }
      }
    }
  },
  setup(props,context){
    let fetching = ref(false);
    let treeData = ref([])
    let deptId = ref('');
    const deptListTree = ( value ) => {
      let params = {}
      fetching.value = true;
      deptApi.deptListTree(params).then((res)=>{
        treeData.value = res;
        fetching.value = false;
      }).catch(()=>{
        fetching.value = false;
      })
    }

    const change = (value) => {
      if(value){
        data.value.forEach((ele)=>{
          if(ele.id == value){

            context.emit('setValue',{
              val : value
            });
          }
        })
      }else{
        context.emit('setValue',{
          val : null
        });
      }

    }

    deptListTree();

    return {
      change,
      deptListTree,
      fetching,
      treeData,
      deptId,
      model : props.model
    }
  },
  watch: {
    value(value) {
      console.log(value);
    },
  },
};
</script>
